import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { supportedMetricsSelector } from '@store/common/selectors';
import { appliedFilterAtom, appliedIntervalAtom } from '../atoms';

function useQueryParams() {
  const { rule: filter, _rKey = 0 } = useAtomValue(appliedFilterAtom);
  const allowedMetrics: any = useSelector(supportedMetricsSelector);
  const interval = useAtomValue(appliedIntervalAtom);

  return {
    interval,
    filter,
    _rKey,
    allowedMetrics,
  };
}

export default useQueryParams;
